import React, { FC, forwardRef, useMemo } from 'react';

import { IconProps } from '../types';
import clsx from 'clsx';

import styles from './styles.module.css';
import { ButtonProps } from '../Button';

type IconButtonProps = ButtonProps & {
  Icon?: FC<IconProps>;
  color?: string;
};

export type Ref = HTMLButtonElement;

export const IconButton = forwardRef<Ref, IconButtonProps>(({ Icon, ...props }, ref) => {
  const {
    variant = 'default',
    intent,
    loading = false,
    disabled = false,
    size = 's',
    fullWidth = false,
    color = 'white',
    className
  } = props;

  // / var(--color-action-primary-normal)
  const iconColor = useMemo(() => {
    let result = color;
    if (variant === 'bare' && intent === 'brand') {
      result = 'var(--color-action-primary-normal)';
    }
    if (variant === 'bare' && intent === 'success') {
      result = 'var(--color-action-success-normal)';
    }
    if (variant === 'bare' && intent === 'destructive') {
      result = 'var(--color-action-primary-normal)';
    }
    return result;
  }, [variant, intent, color]);

  return (
    <button
      ref={ref}
      {...props}
      className={clsx(
        styles.base,
        styles[variant],
        intent && styles[`_${intent}`],
        styles[`_${size}`],
        loading && styles[`_loading`],
        disabled && styles[`_disabled`],
        fullWidth && styles[`_full`],
        className
      )}
    >
      {Icon && <Icon size={size} color={iconColor} />}
    </button>
  );
});

IconButton.displayName = 'IconButton';

export default IconButton;
